import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useModalFooterStyles = makeStyles({
  modalFooter: {
    margin: props => !props.modalHasNoMargin ? '32px -40px 0 -40px' : '',
    padding: props => !props.modalHasNoPadding ? '32px 40px 0px 40px' : '32px 40px',
    borderTop: "1px solid ".concat(palette.shades[300]),
    [breakpointsFunc.breakpoints.down('lg')]: {
      margin: props => !props.modalHasNoMargin ? '40px -24px 0 -24px' : '',
      padding: props => !props.modalHasNoPadding ? '40px 40px 0px 40px' : '40px 40px'
    },
    [breakpointsFunc.breakpoints.down('sm')]: {
      margin: props => !props.modalHasNoMargin ? '24px -24px 0 -24px' : '',
      padding: props => !props.modalHasNoPadding ? '24px 24px 0px 24px' : '24px 24px'
    }
  },
  modalFooterStandart: {
    padding: '32px 40px 32px 40px',
    borderTop: "1px solid ".concat(palette.shades[300])
  },
  modalFooterStandartSmall: {
    padding: '12px 16px 12px 16px',
    borderTop: "1px solid ".concat(palette.shades[300])
  },
  footerEven: {
    display: 'flex',
    justifyContent: 'space-between',
    [breakpointsFunc.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse'
    }
  },
  footerButton: {
    display: 'inline-block',
    '& + &': {
      marginLeft: '10px'
    },
    [breakpointsFunc.breakpoints.down('sm')]: {
      width: '100%',
      '& + &': {
        marginTop: '10px',
        marginLeft: '0'
      },
      '& button': {
        width: '100%'
      }
    }
  },
  footerWrapper: {
    display: 'flex',
    [breakpointsFunc.breakpoints.down('sm')]: {
      flexDirection: 'column',
      '& + &': {
        marginBottom: '10px'
      }
    }
  }
});
export default useModalFooterStyles;